import { DISABLE_QUERY_ON_FILTERS_CHANGE, ENABLE_QUERY_ON_FILTERS_CHANGE } from '../actions'
import { createEnableDisableReducer } from '../../../utility/state'

/**
 * @typedef {boolean} QueryOnFiltersChangeState Whether new results should be queried when filters change
 */

/**
 * @param {QueryOnFiltersChangeState} initialState
 * @returns {(state: QueryOnFiltersChangeState, action: Object) => QueryOnFiltersChangeState}
 */
export default function queryOnFiltersChangeReducer(initialState) {
    return createEnableDisableReducer(initialState, ENABLE_QUERY_ON_FILTERS_CHANGE, DISABLE_QUERY_ON_FILTERS_CHANGE)
}
